import { getCall as getCallHelper } from '../../../helpers/api/api'
import { login } from '../../../store/actions/auth'

export const getCall = async (endpoint, body = {}) => {
    try {
        return await getCallHelper(endpoint, body)
    }
    catch (err) {
        if (err.message === "Request failed with status code 401") {
            login("")
        }
    }
}